<template>
  <CreateTaskModal
    v-if="showTaskModal && defaultTask != null"
    v-model:visible="showTaskModal"
    :default-task="defaultTask"
    :event="event"
    @update:visible-action-modal="showTaskModal = $event"
  />
</template>

<script setup lang="ts">
import { type PropType, ref, computed, inject } from "vue";
import {
  type EventListEventFieldsFragment,
  type GetEABShorthandsForBoardFragmentFragment,
  useCreateTaskMutation,
} from "@/graphql";
import CreateTaskModal from "@/components/event-action/task/modal/CreateTaskModal.vue";
import { createShorthandAction } from "../../helper/CreateShorthand";
import type { WorkflowEABType } from "../../helper/eabShorthandEditType";
import type { EditTaskType } from "@/components/event-action/task/helper/DefaultTask";
import { BoardIdInjectionKey } from "@/views/event-action/EventActionBoardInjectionKeys";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  event: {
    type: Object as PropType<EventListEventFieldsFragment>,
    required: true,
  },
  shorthand: {
    type: Object as PropType<GetEABShorthandsForBoardFragmentFragment>,
    required: true,
  },
  workflow: {
    type: Object as PropType<WorkflowEABType>,
    required: false,
    default: null,
  },
});
const { mutate } = useCreateTaskMutation({});
const boardId = inject(BoardIdInjectionKey, null);

const showTaskModal = ref(false);

const defaultTask = ref<EditTaskType>();

function createShorthandActionFunction() {
  const task = createShorthandAction(
    props.event,
    mutate,
    props.workflow?.node.id,
    props.shorthand,
    boardId?.value ?? undefined,
  ) as EditTaskType;
  defaultTask.value = undefined;
  if (task != null) {
    defaultTask.value = task;
    showTaskModal.value = true;
  }
}
defineExpose({
  createShorthandActionFunction,
});
computed(() =>
  props.workflow == null
    ? undefined
    : {
        placement: "right",
        title: props.workflow.description,
      },
);
</script>

<style lang="scss" scoped></style>
